import FunctionPanel from '../components/FunctionPanel';

const UPLOAD_FIELDS = [
    { key: 'source', label: '模特图', required: true, showMaterialLibrary: false },
    { key: 'reference', label: '参考模特图', required: true },
];
const REQUIRE_PERSON_UPLOAD_KEYS = ['source', 'reference'];

const CreativeColorPanel = (props) => (
    <FunctionPanel
        panelKey="creativeColor"
        uploadFields={UPLOAD_FIELDS}
        panelWidth={390}
        hintText="*建议使用单色或双色服装，复杂花纹可能影响配色效果"
        beanCost={10}
        advancedOptions={{
            showAdvancedSection: false,
            includeOrientationParam: false,
            includeExpressionParam: false,
            includeKeepHeadwearParam: false,
            includeSkipSelectParam: false,
            uploadParamKeyMap: {
                source: 'srcImage',
                reference: 'refImage',
            },
            repaintMaskParamKeyMap: {
                source: 'srcImageRepaintBinaryMask',
                reference: 'refImageRepaintBinaryMask',
            },
            showUploadSourceActions: true,
            uploadCardVariant: 'upscale',
            checkPersonOnUpload: true,
            requirePersonUploadKeys: REQUIRE_PERSON_UPLOAD_KEYS,
        }}
        {...props}
    />
);

export default CreativeColorPanel;
